var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import * as React from 'react';
import omit from 'lodash/omit';
import uniqueId from 'lodash/uniqueId';

var AccessibleSVG = function (_React$Component) {
    _inherits(AccessibleSVG, _React$Component);

    function AccessibleSVG() {
        _classCallCheck(this, AccessibleSVG);

        return _possibleConstructorReturn(this, (AccessibleSVG.__proto__ || Object.getPrototypeOf(AccessibleSVG)).apply(this, arguments));
    }

    _createClass(AccessibleSVG, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            this.id = uniqueId('icon');
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                children = _props.children,
                title = _props.title,
                rest = _objectWithoutProperties(_props, ['children', 'title']);

            var titleID = this.id + '-title';

            // Make sure parent doesn't accidentally override these values
            var svgProps = omit(rest, ['role', 'aria-labelledby']);

            // Accessibility fix for IE11, which treats all SVGs as focusable by default
            svgProps.focusable = 'false';

            if (title) {
                svgProps['aria-labelledby'] = titleID;
                svgProps.role = 'img';
            } else {
                svgProps.role = 'presentation';
            }

            return React.createElement(
                'svg',
                svgProps,
                title ? React.createElement(
                    'title',
                    { id: titleID },
                    title
                ) : null,
                children
            );
        }
    }]);

    return AccessibleSVG;
}(React.Component);

AccessibleSVG.propTypes = {
    children: PropTypes.node.isRequired,

    /** A text-only string describing the icon if it's not purely decorative for accessibility */
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.node])
};


export default AccessibleSVG;
import PropTypes from 'prop-types';